import { v4 as uuidv4 } from 'uuid';
import { safeStorage } from '@gjensidige/service-storage';

import { TopicSelectionState } from '../redux/slices/topic-selection';

enum SessionKey {
  BoostSessionId = 'chat.boost-sessionId',
  DidRefresh = 'chat.didRefresh',
  WindowIsVisible = 'chat.chatWindowIsVisible',
  ChatState = 'chat.chatState',
  NumberOfUnreadMessages = 'chat.numberOfUnreadMessages'
}

// Cypress doesn't like the safe storage
const storage =
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  process.env.NODE_ENV === 'development' && window.Cypress
    ? sessionStorage
    : safeStorage('session');

export const chatSession = {
  setDidRefresh(value: boolean) {
    storage.setItem(SessionKey.DidRefresh, value.toString());
  },
  didRefresh: () => storage.getItem(SessionKey.DidRefresh) === 'true',
  setWindowVisible(value: boolean) {
    storage.setItem(SessionKey.WindowIsVisible, value.toString());
  },
  isWindowVisible: () => storage.getItem(SessionKey.WindowIsVisible) === 'true',
  hasSavedState: () => SessionKey.ChatState in storage,
  getSavedState() {
    const state = storage.getItem(SessionKey.ChatState);
    return state ? JSON.parse(state) : {};
  },
  clearSavedState: () => storage.removeItem(SessionKey.ChatState),
  saveState(state: TopicSelectionState) {
    storage.setItem(
      SessionKey.ChatState,
      JSON.stringify({
        topicSelection: state
      })
    );
  },
  getNumberOfUnreadMessages: () =>
    parseInt(storage.getItem(SessionKey.NumberOfUnreadMessages) ?? '0'),
  setNumberOfUnreadMessages(value: number) {
    storage.setItem(SessionKey.NumberOfUnreadMessages, value.toString());
  }
};

export const boostSession = {
  exists: () => SessionKey.BoostSessionId in storage,
  getId() {
    if (!boostSession.exists()) {
      storage.setItem(SessionKey.BoostSessionId, uuidv4());
    }
    return storage.getItem(SessionKey.BoostSessionId);
  },
  clear: () => storage.removeItem(SessionKey.BoostSessionId)
};
